import axios from "axios";
import { WITHDRAWAL_HISTORY_URL } from "../utils";

export const fetchWithdrawalHistory = async () => {
  return await axios.get(WITHDRAWAL_HISTORY_URL);
};
